import { useTranslation } from 'react-i18next';

import * as NutriScoreLabel from 'types/NutriScore/NutriScoreLabel';
import * as NutriScoreLabelList from 'types/NutriScore/NutriScoreLabelList';

interface IProps {
	all: NutriScoreLabelList.Type;
	handleChange: (input: { saved: string; all: NutriScoreLabelList.Type }) => void;
	saved: string[];
}

const NutriScoreDiagramSelectNew = (props: IProps) => {
	const { t } = useTranslation();

	const renderLabel = (input: NutriScoreLabel.Type, key: number): JSX.Element => {
		if (input.ids.some((x) => props.saved.includes(x))) {
			return (
				<div
					key={key}
					className="nutri-score-diagram-score score"
					onClick={() => props.handleChange({ saved: input.label, all: props.all })}
					style={{ backgroundColor: input.color, opacity: 1 }}
				>
					<span className="nutri-score-label">{input.label}</span>
				</div>
			);
		} else {
			return (
				<div
					key={key}
					className="nutri-score-diagram-score score"
					onClick={() => props.handleChange({ saved: input.label, all: props.all })}
					style={{ backgroundColor: input.color, opacity: 0.3 }}
				>
					<span className="nutri-score-label">{input.label}</span>
				</div>
			);
		}
	};

	return (
		<div className="nutri-score-diagram-container-outer">
			<label>{t('_general:NUTRI_SCORE')}</label>
			<div className="nutri-score-diagram-container-inner">
				{props.all.map((e: NutriScoreLabel.Type, i: number) => renderLabel(e, i))}
			</div>
		</div>
	);
};

export default NutriScoreDiagramSelectNew;
